import { SupabaseService } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";
import type { UUID } from "../../../utils/uuid";
import type { PostgrestResponse, PostgrestSingleResponse } from "@supabase/postgrest-js";

export type EmailDesign = Database["public"]["Tables"]["email_design"]["Row"];

export class SupabaseEmailDesignService extends SupabaseService<"email_design"> {
  table = "email_design" as const;

  async getDefaultDesignId(): Promise<PostgrestSingleResponse<Pick<EmailDesign, "id"> | null>> {
    return this.log_errors(
      await this.client.from("email_design").select("id").eq("is_default", true).single(),
    );
  }

  /** The account's default design, for a moment that names none of its own. */
  async maybeGetDefault(): Promise<PostgrestSingleResponse<EmailDesign | null>> {
    return this.log_errors(
      await this.client
        .from("email_design")
        .select<"*", EmailDesign>()
        .eq("is_default", true)
        .maybeSingle(),
    );
  }

  async setDefault(email_design_id: UUID): Promise<PostgrestResponse<EmailDesign>> {
    return this.log_errors(await this.client.rpc("set_default_email_design", { email_design_id }));
  }

  async archive(
    email_design_id: UUID,
    new_email_design_id: UUID,
  ): Promise<PostgrestSingleResponse<boolean>> {
    return this.log_errors(
      await this.client.rpc("archive_email_design", {
        email_design_id_: email_design_id,
        new_email_design_id,
      }),
    );
  }
}
